import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-errors',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './errors.component.html',
    styleUrls: ['./errors.component.scss'],
    standalone: false
})
export class ErrorsComponent {
  constructor(public navigationControlService: NavigationControlService) {
  }

  goToHomepage() {
    this.navigationControlService.goHome();
  }
}
